import { PlatformConfiguration } from '../model';

export const configuration: PlatformConfiguration = {
  button: {
    background: 'gradient',
    type: 'primary',
  },
  input: {
    label: 'inline',
  },
  amountInput: {
    variant: 'outlined',
    border: 'standard',
  },
  errors: {
    position: 'top',
    type: 'default',
  },
  balance: {
    visible: false,
  },
};
